import { faRedditAlien } from "@fortawesome/free-brands-svg-icons"
import { AwesomeIcon } from "component_old/micro/view/AwesomeIcon"
import { CtxModal } from "component_old/modal/ctxModal"
import { EColors, EFonts } from "libs/style/styling"
import { EScrolls, scrollToAnchor } from "libs/utils/logic/browserLogic"
import React, { useContext } from "react"
import styled from "styled-components/macro"

interface Props {
  items: { name: string; scroll: EScrolls }[]
  className?: string
}

export const MobileMenu = (props: Props): JSX.Element => {
  const ctxModal = useContext(CtxModal)

  return (
    <S_MobileMenu className={props.className}>
      {props.items.map(item => {
        return (
          <S_Item
            key={item.name}
            onClick={() => {
              document.querySelector("body").style.overflow = "unset"
              scrollToAnchor(item.scroll, "auto")
              ctxModal.changeModal(null)
            }}
          >
            {item.name}
          </S_Item>
        )
      })}
      <S_Item>
        <a
          href="https://www.reddit.com/r/mapheim/"
          target="_blank"
          rel="noreferrer"
        >
          <AwesomeIcon
            icon={faRedditAlien}
            iconSize="16px"
            color={EColors.DARK}
          />
        </a>
      </S_Item>
    </S_MobileMenu>
  )
}

const S_MobileMenu = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const S_Item = styled.div`
  width: 100%;
  padding: 25px 0;
  border-bottom: 1px solid ${EColors.GREY2};
  color: ${EColors.DARK};
  font-size: 16px;
  font-family: ${EFonts.Medium};
  text-align: center;
`
